import { useAddToListMutationsUpdateMembershipsMutation } from '#app/__generated__/relay/useAddToListMutationsUpdateMembershipsMutation.graphql.js';
import { useContraMutation } from '#app/hooks/useContraMutation.js';
import { graphql } from '@contra/relay';

export const useAddToListMutations = () => {
  const [updateListMemberships, isUpdatingListMemberships] =
    useContraMutation<useAddToListMutationsUpdateMembershipsMutation>(graphql`
      mutation useAddToListMutationsUpdateMembershipsMutation(
        $input: UpdateUsersMembershipsInUserListsInput!
        $userProfileId: ID!
      ) {
        updateUsersMembershipsInUserLists(input: $input) {
          errors {
            __typename
            message
          }
          visitor {
            userAccount {
              ...AddToListMenu_userAccount
                @arguments(userProfileId: $userProfileId)
              userLists(first: 200, filter: { groupNid: NETWORK_LIST }) {
                edges {
                  node {
                    id
                    isUserProfileInList(userProfileId: $userProfileId)
                  }
                }
              }
            }
          }
        }
      }
    `);

  return { isUpdatingListMemberships, updateListMemberships };
};
